import { apiClient } from '@plerionhq/design-system';
import Auth from './auth';

export const API_ENDPOINT = process.env.API_URL || '';

apiClient.interceptors.request.use(function (config) {
  const token = Auth.getOAuthToken();
  if (token && config?.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default apiClient;
